export default __webpack_public_path__ + "static/media/fi_more.c1435ca8.svg";